import React from 'react';

const ControlledAccess = () => {
  return (
    <div>
      
      <h3>Access Restricted to Non-Warehouse Users</h3>
    </div>
  );
};

export default ControlledAccess;